export const environment = {
  production: false,
  productLogo: '/assets/vigil-identity.svg',
  features: {},
};
